import { render, staticRenderFns } from "./DepotPiece.vue?vue&type=template&id=23a29afe&"
import script from "./DepotPiece.vue?vue&type=script&lang=js&"
export * from "./DepotPiece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports